var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDotWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.833344C11.7961 0.83324 13.5526 1.36077 15.0514 2.35043C16.5503 3.34008 17.7253 4.74824 18.4307 6.4C19.1361 8.05177 19.3406 9.87437 19.019 11.6414C18.6974 13.4085 17.8638 15.0421 16.6217 16.3394C15.3796 17.6367 13.7837 18.5406 12.0323 18.9387C10.2809 19.3368 8.45114 19.2116 6.77028 18.5787C5.08941 17.9457 3.63152 16.833 2.57767 15.3786C1.52382 13.9242 0.920445 12.1922 0.842495 10.3978L0.833328 10L0.842495 9.60218C0.945014 7.24222 1.95461 5.01294 3.66074 3.37922C5.36687 1.7455 7.63781 0.83348 9.99999 0.833344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDotWhite);
export default __webpack_public_path__ + "static/media/Icon_Dot_White.6ed50c4e84edf298b5ec658b79e5237c.svg";
export { ForwardRef as ReactComponent };